import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import Button from '../../../shared/components/Button';
import TextInput from '../../../shared/components/TextInput';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';

import { 
  alphabeticallySort,
  textContains,
  getWelcomeLinkForUser
} from '../../../shared/utils';


class ProviderPendingUserList extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    this.props.loadPendingUsers()
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  render(){
    //TODO: Render ProviderPendingUserList
    return (
      <Row>
        <Col xs='12'>
          <SearchableDataTable 
            items={this.props.users}
            emptyText='Loading pending users...'
            searchPromptText='Search by email'    
            columns={[
              {
                width:50,
                name:'email',
                filterFunc:(a,searchParam) => textContains(a.email,searchParam),
                renderCell:(item) => (
                  <a href={`mailto:${item.email}`}>
                    {item.email}
                  </a>
                )
              },{
                width:50,
                name:'inviteLink',
                display:'Confirm Email Link',
                renderCell:(item) => (
                  <div className='pull-right' style={{width:'100%'}}>
                    <TextInput 
                      readOnly
                      copyPaste
                      value={getWelcomeLinkForUser(item)}  
                    />
                  </div>
                )
              }
            ]}        
          />
        </Col>
      </Row>
    );
  }
}

ProviderPendingUserList.propTypes = {
  //TODO: Fill in prop types for ProviderPendingUserList
};

ProviderPendingUserList.defaultProps = {
  //TODO: Fill in defaultProps for ProviderPendingUserList
};

export default ProviderPendingUserList;



// WEBPACK FOOTER //
// ./src/routes/ProviderPendingUserList/components/ProviderPendingUserList.js